import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCollapseVertical$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCollapseVertical extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'faaf89e0c64acb161d5a95b7dfe2951e19b1392b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '83ae4cc20af348dd27c5410a9d77718dcd8424cd', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7f84d2e26cd366eb28cde5f66f89fda05ad8ab0c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.871 4.387c.293-.346.055-.887-.39-.887H8.519c-.444 0-.682.541-.389.887l2.482 2.93a.507.507 0 0 0 .778 0zM3.001 10.75a.5.5 0 0 1 .5-.5H18.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5zm5.517 7.75c-.444 0-.682-.541-.389-.887l2.482-2.93a.506.506 0 0 1 .778 0l2.482 2.93c.293.346.055.887-.39.887z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-collapse-vertical", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-collapse-vertical"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-collapse-vertical":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCollapseVertical$1);
            }
            break;
    } });
}

const CosmosIconCollapseVertical = CosmosIconCollapseVertical$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCollapseVertical, defineCustomElement };
